(function () {
  'use strict';

  function initSFProduct() {
    const section = document.querySelector('.sf-product-section');
    if (!section) return;

    let qty = 1;
    let isSubscribe = false;

    // ── size / variant buttons ──
    section.querySelectorAll('.sf-size-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        section.querySelectorAll('.sf-size-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        updatePricing();
      });
    });

    // ── purchase type toggle ──
    section.querySelectorAll('.sf-purch-opt').forEach(opt => {
      opt.addEventListener('click', () => {
        section.querySelectorAll('.sf-purch-opt').forEach(o => o.classList.remove('sel'));
        opt.classList.add('sel');
        isSubscribe = opt.dataset.type === 'sub';
        updatePricing();
        const atcBtn = section.querySelector('.sf-btn-atc');
        if (atcBtn) {
          atcBtn.textContent = isSubscribe ? '🔄 Subscribe & Add to Cart' : '🛒 Add to Cart';
        }
      });
    });

    // ── quantity ──
    section.querySelectorAll('.sf-qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const delta = parseInt(btn.dataset.delta, 10);
        qty = Math.max(1, qty + delta);
        const num = section.querySelector('.sf-qty-num');
        if (num) num.textContent = qty;
      });
    });

    // ── pricing ──
    function updatePricing() {
      const activeBtn = section.querySelector('.sf-size-btn.active');
      if (!activeBtn) return;

      const priceRaw  = parseFloat(activeBtn.dataset.price  || 0);
      const subRaw    = priceRaw * 0.85;
      const priceFmt  = activeBtn.dataset.priceFmt || fmtMoney(priceRaw);
      const subFmt    = fmtMoney(subRaw);

      const display  = section.querySelector('#sf-price-display');
      const oncePr   = section.querySelector('#sf-once-pr');
      const subOld   = section.querySelector('#sf-sub-old');
      const subPr    = section.querySelector('#sf-sub-pr');

      if (display) display.textContent = isSubscribe ? subFmt : priceFmt;
      if (oncePr)  oncePr.textContent  = priceFmt;
      if (subOld)  subOld.textContent  = priceFmt;
      if (subPr)   subPr.textContent   = subFmt;

      // update atc button variant id
      const atcBtn = section.querySelector('.sf-btn-atc');
      if (atcBtn && activeBtn.dataset.variantId) {
        atcBtn.dataset.variantId = activeBtn.dataset.variantId;
      }
    }

    function fmtMoney(amount) {
      return '$' + amount.toFixed(2);
    }

    // ── add to cart ──
    const atcBtn = section.querySelector('.sf-btn-atc');
    if (atcBtn) {
      atcBtn.addEventListener('click', async () => {
        const variantId = atcBtn.dataset.variantId;
        if (!variantId || variantId === '0') {
          window.location = section.dataset.productUrl || '/products';
          return;
        }
        const originalText = atcBtn.textContent;
        atcBtn.textContent = 'Adding…';
        atcBtn.classList.add('loading');
        try {
          const resp = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
          });
          if (resp.ok) {
            window.location = '/cart';
          } else {
            atcBtn.textContent = originalText;
            atcBtn.classList.remove('loading');
          }
        } catch (e) {
          atcBtn.textContent = originalText;
          atcBtn.classList.remove('loading');
        }
      });
    }

    // init pricing on load
    updatePricing();
  }

  // ── thumbnail switcher ──
  function initSFThumbs() {
    document.querySelectorAll('.sf-product-thumbs').forEach(gallery => {
      gallery.querySelectorAll('.sf-thumb').forEach((thumb, i) => {
        thumb.addEventListener('click', () => {
          gallery.querySelectorAll('.sf-thumb').forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
          const main = gallery.closest('.sf-product-images')?.querySelector('.sf-product-main-img img');
          const src  = thumb.querySelector('img')?.src;
          if (main && src) main.src = src;
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { initSFProduct(); initSFThumbs(); });
  } else {
    initSFProduct();
    initSFThumbs();
  }
})();
